import { ProfileCard } from "@components/Cards";

export const Profile = () => {
  return <ProfileCard />;
};
